import { wrapper } from "../../redux";
import Articles from "../../components/pages/articles";
import Redis from "/lib/redis";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { newsListLogic } from "../../pagesSrrLogic/news";
import { sspWrapper } from "../../utils/errors/sspWrapper";

export default function NashePortfolioPage({
  scripts,
  host,
  isFarkop,
  isLanding,
  isBaltex,
  code,
  title,
  sections,
  section,
  newsItems,
  imageReset,
  size,
  currentPage,
}) {
  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <Articles
        code={code}
        title={title}
        isFarkop={isFarkop}
        isLanding={isLanding}
        isBaltex={isBaltex}
        section={section}
        sections={sections}
        newsItems={newsItems}
        imageReset={imageReset}
        size={size}
        currentPage={currentPage}
      />
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ query, req, resolvedUrl }) => {
    return newsListLogic(
      Redis,
      store,
      query,
      req,
      resolvedUrl,
      "nashe-portfolio",
      "Портфолио",
      { filterByDomain: false },
    );
  }),
);
